import Region from './Region';

export default Region;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Region/index.ts